<template>
  <div>
    <NavPage></NavPage>
    <div class="content">
      <SlideShow></SlideShow>
    </div>
    <ProjectPage></ProjectPage>
    <FooterPage></FooterPage>
  </div>
</template>

<script>
import NavPage from "@/components/NavPage.vue";
import SlideShow from "@/components/SlideShow.vue";
import FooterPage from "@/components/FooterPage.vue";
import ProjectPage from '@/components/ProjectPage.vue'
export default {
  name: "ProjectCase",
  components: {
    NavPage,
    FooterPage,
    SlideShow,
    ProjectPage
  },
};
</script>

<style scoped>
.content {
  width: 1340px;
  margin: auto;
}
</style>